import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import loaderIcon from '../../src/assets/json/loader.json';
import Logo from '../../src/assets/images/alohaaLogoAndBottomText.png';
import { useAuth } from '../providers/AuthProvider';
import { GET } from "../services/HttpRequests";
import { useNavigate } from 'react-router-dom';
import failIcon from '../../src//assets/json/fail.json';

const orgUrl = process.env.REACT_APP_ORGANIZATION_API;
const loadingOption = {
		loop: true,
		autoplay: true,
		animationData: loaderIcon,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};
const failOption = {
  loop: true,
  autoplay: true,
  animationData: failIcon,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const SsoAuthCallback = () => {
	const { saveSession } = useAuth();
	const [loginStatus, setLoginStatus] = useState('processing');
	const navigate = useNavigate();
	useEffect(() => {
		verifySsoToken();
  }, []);

	const verifySsoToken = () => {
		GET(orgUrl + `v1/auth/alohaa-widget/google/login${window.location.search}`)
      .then((res) => {
        return res.data.response;
      })
      .then((res) => {
				if (res.role === 'USER' || res.role === 'user') {
          // saveSession(res);
				  // navigate('/');
          // window.location.reload();
					window.opener.postMessage(
          {
            type: 'GOOGLE_LOGIN_SUCCESS',
            res,
          },
          window.location.origin
        );
				} else {
					setLoginStatus("failed");
					window.opener.postMessage(
          {
            type: 'GOOGLE_LOGIN_ERROR',
            error: "Failed",
          },
          window.location.origin
        );
				}
				window.close();
      }).catch(err => {
        const errorMessage = err.response?.data?.error?.reason ?? "Something went wrong!";
        // setLoginErrorMessage(errorMessage)
        setLoginStatus("failed");
				window.opener.postMessage(
          {
            type: 'GOOGLE_LOGIN_ERROR',
            error: "Failed",
          },
          window.location.origin
        );
			  window.close();
      });
	};

	return (
		<div style={{ width: '100%', minHeight: '100vh' }}>
			<div>
				<div
					style={{
						minHeight: '175px',
						boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.16)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<img className="login-container-logo" alt="" src={Logo} />
				</div>

				{loginStatus === 'processing' && (
					<div
						style={{
							minHeight: '600px',
							flexDirection: 'column',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<Lottie options={loadingOption} height={400} width={400} />
						<p
							style={{
								fontFamily: 'Inter',
								fontSize: '34px',
								fontWeight: 'bold',
								letterSpacing: '-1.02px',
								color: '#454545',
							}}
						>
							Verifying your account details
						</p>
						<p
							style={{
								fontFamily: 'Inter',
								fontSize: '24px',
								fontWeight: '500',
								letterSpacing: '-0.72px',
								color: '#454545',
							}}
						>
							This may take a moment
						</p>
					</div>
				)}

				{loginStatus === 'failed' && (
          <div
            style={{
              minHeight: '600px',
              flexDirection: 'column',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Lottie options={failOption} height={400} width={400} />
            <p
              style={{
                fontFamily: 'Inter',
                fontSize: '34px',
                fontWeight: 'bold',
                letterSpacing: '-1.02px',
                textAlign: 'center',
                color: '#ed3833',
              }}
            >
            </p>
            <p>
              <br /> Please contact <a href="mailto:support@alohaa.ai">support@alohaa.ai</a> for further help.
            </p>
          </div>
        )}


			</div>
		</div>
	)
};

export default SsoAuthCallback;